import cx from 'classnames'
import styles from './Hero.module.scss'
import { openWhatsApp } from '../constants'

// Served from public/ rather than imported so index.html can <link rel=preload>
// it: this photo is the LCP element and a hashed bundler URL is not knowable at
// build time. Keep the -vN suffix in sync with the preload tag in index.html.
const fotoFrancis = `${process.env.PUBLIC_URL}/hero-francis-v1.webp`

const HIGHLIGHTS = [
  { icon: 'verified', label: 'Atendimento\n100% online' },
  { icon: 'person', label: 'Acompanhamento\nindividualizado' },
  { icon: 'public', label: 'Para todo Brasil\ne exterior' },
]

const Hero = () => (
  <section id="inicio" className={styles.hero}>
    <div className={styles.inner}>
      <div className={styles.text}>
        <h1>
          Fonoaudiologia online para <span>crianças e adultos</span>
        </h1>
        <p className={styles.lead}>
          Atendimento especializado para desenvolver a comunicação, a fala, a
          linguagem e a voz em pacientes a partir dos 4 anos de idade.
        </p>

        <ul className={styles.highlights}>
          {HIGHLIGHTS.map(item => (
            <li key={item.icon}>
              <i className="material-icons">{item.icon}</i>
              <span>{item.label}</span>
            </li>
          ))}
        </ul>

        <button type="button" className={styles.cta} onClick={openWhatsApp}>
          Agendar avaliação <i className="material-icons">chat</i>
        </button>
        <p className={styles.note}>Atendimento humanizado e baseado em evidências</p>
      </div>

      <div className={styles.media}>
        <div className={cx(styles.blob)} />
        <img
          src={fotoFrancis}
          alt="Fonoaudióloga Francis Guimarães em atendimento online"
          width={848}
          height={1248}
          decoding="async"
        />
      </div>
    </div>
  </section>
)

export default Hero
